export class StringUtils {

    public static notNullOrEmpty(val: string) {
        return val && val != '';
    }
}


// WEBPACK FOOTER //
// ./src/app/core/components/common/string-utils.ts